import { CSSProperties } from 'react';
import { antGrey, statusElement } from './globalStyles';

const releaseItem = {
    minMarginLeft: 6,
    minMarginRigth: 6,
};

const styles = {
    timelineStyle: {
        backgroundColor: antGrey.grey3,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        height: '100%',
        borderRightColor: antGrey.grey5,
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        justifyContent: 'space-between',
    } as CSSProperties,
    timelineHeaderStyle: {} as CSSProperties,
    timelineContent: {
        paddingLeft: 36,
        paddingRight: 16,
    } as CSSProperties,
    mainTimeline: {
        padding: 6,
    } as CSSProperties,
    timelineList: {
        listStyleType: 'none',
    } as CSSProperties,
    status: {
        ...statusElement,
    } as CSSProperties,
    releaseContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    } as CSSProperties,
    releaseVersion: {
        ...releaseItem,
        marginLeft: 12,
        marginRight: 12,
    } as CSSProperties,
    releaseCreatedAt: {
        ...releaseItem,
    } as CSSProperties,
    navigationContainer: {
        height: 30,
        width: 30,
    } as CSSProperties,
};

export default styles;
